import { render, staticRenderFns } from "./WorkSituation.vue?vue&type=template&id=3411b463&scoped=true&"
import script from "./WorkSituation.vue?vue&type=script&lang=js&"
export * from "./WorkSituation.vue?vue&type=script&lang=js&"
import style0 from "./WorkSituation.vue?vue&type=style&index=0&id=3411b463&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3411b463",
  null
  
)

export default component.exports